import { createApp } from 'vue';
import './registerServiceWorker';
import router from './router';
import { View as RouterView } from 'vue-router';

// Global styles
import 'bootstrap/scss/bootstrap.scss';
import './style/global.scss';

/* eslint import/no-duplicates: "off" */
import './store';
import { Ready, musicStore } from './store';

(async () => {
  await Ready;
  await musicStore.load();
  createApp(RouterView).use(router).mount('#app');
})();
